<template>
	<div class="c-keyboard-shortcuts">
		<div class="container-fluid">
			<div class="row">
				<div class="col">
					<h2>Keyboard shortcuts</h2>
					<p>Click any key to highlight the keyboard shortcut</p>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<span class="key" ref="ArrowUp">Up arrow</span> /
					<span class="key" ref="ArrowDown">Down arrow</span><br />
					<span class="key" ref="w">W</span> /
					<span class="key" ref="s">S</span>
				</div>
				<div class="col-md-6">
					<p>
						Move up or down the list. The preview panel will update
						automatically.
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<span class="key" ref="Space">Spacebar</span>
				</div>
				<div class="col-md-6">
					<p><em>[When moving up or down the list]</em>Expand the next group</p>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<span class="key" ref="e">e</span>
				</div>
				<div class="col-md-6">
					<p><em>[When selection is active]</em> Export notes.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<span class="key" ref="Escape">Esc</span>
				</div>
				<div class="col-md-6">
					<p>
						<em>[When a modal is active]</em> Dismiss modal.
						<br />
						<em>[When selection is active]</em> Dismiss selection.
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<span class="key" ref="c">c</span>
				</div>
				<div class="col-md-6">
					<p>Set a quick copy style</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import anime from 'animejs';

export default {
	methods: {
		onKeyDown: function (e) {
			e.preventDefault();
			let keys = [
				'ArrowUp',
				'ArrowDown',
				'Shift',
				'e',
				'Escape',
				'c',
				'w',
				's',
				'Space',
			];
			if (keys.includes(e.key)) {
				let el = this.$refs[e.key];
				if (el) {
					this.animate(el);
				}
			} else if (keys.includes(e.code)) {
				let el = this.$refs[e.code];
				if (el) {
					this.animate(el);
				}
			}
		},
		animate: function (el) {
			anime({
				targets: el,
				duration: 200,
				backgroundColor: ['rgba(255,255,255,0.2', 'rgba(255,255,255,0.05'],
				easing: 'easeInOutQuad',
			});
		},
		addEventListeners: function () {
			document.addEventListener('keydown', this.onKeyDown);
		},
		removeEventListeners: function () {
			document.removeEventListener('keydown', this.onKeyDown);
		},
	},
	mounted: function () {
		this.addEventListeners();
	},
	beforeDestroy: function () {
		this.removeEventListeners();
	},
};
</script>

<style lang="scss">
.c-keyboard-shortcuts {
	.key {
		display: inline-block;
		padding: 4px 8px;
		border-radius: 5px;
		background-color: rgba(255, 255, 255, 0.05);
		font-size: 15px;
		font-weight: 500;
		letter-spacing: 0.2px;
	}
	em {
		color: $primary;
	}
}
</style>
